import { useEffect, useState } from "react";
import ContentsTopHeader from "../../../components/common/contents.top.header";
import {
  BackupUserContainer,
  ContentsBody,
} from "../../../style/contents/backup/backup";
import { fetchBackupUserListLoad } from "../../../api/admin";
import UserList from "../../../components/backup/user.list";
import { useAuthStore } from "../../../atoms/user.auth.store";
import { Navigate } from "react-router-dom";
import Select from "react-select";

export interface BackupUser {
  userId: number;
  userAccount: string;
  password: string;
  companyId: number;
  macAddress: string[];
  createdDate: string;
  department: string;
  isAdmin: boolean;
  jobPosition: string;
  phoneNumber: string;
  userEmail: string;
  userName: string;
  pcName: string;
}

type BackupUserList = BackupUser[];

const tableSort = [
  { value: "name", label: "이름순" },
  { value: "department", label: "부서순" },
];

const BackupUser = () => {
  const { role } = useAuthStore();

  const [redirect404, setRedirect404] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageSize, setPageSize] = useState("10");
  const [data, setData] = useState<BackupUserList>([]);
  const [isLoading, setIsLoading] = useState(true); // ✅ 추가

  const handleSearch = (keyword: string) => {
    setSearchKeyword(keyword);
    // TODO: fetchData(keyword, pageSize);
    console.log(searchKeyword);
  };

  console.log(data);

  const handlePageSizeChange = (option: any) => {
    setPageSize(option.value);
    // TODO: fetchData(searchKeyword, size);
  };

  useEffect(() => {
    if (role === "user") {
      setRedirect404(true);
      return;
    }

    const loadUserList = async () => {
      setIsLoading(true); // ✅ 시작
      const userId = localStorage.getItem("userId");
      const companyCode = localStorage.getItem("companyCode");

      try {
        const response = await fetchBackupUserListLoad(
          Number(userId),
          companyCode || ""
        );
        setData(response.userList);
      } catch (err) {
        console.error("❌ 사용자 목록 불러오기 실패", err);
      } finally {
        setIsLoading(false); // ✅ 완료
      }
    };
    loadUserList();
  }, [role]);

  // ✅ 렌더링 전 조건 분기
  if (redirect404) {
    return <Navigate to="/404" replace />;
  }

  // ✅ 검색어에 따라 필터링된 데이터 생성
  const filteredData = data.filter((user) =>
    user.userAccount.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  // ✅ 정렬 기준에 따라 정렬된 데이터 생성
  const sortedData = [...filteredData].sort((a, b) => {
    if (pageSize === "name") {
      return a.userName.localeCompare(b.userName);
    } else if (pageSize === "department") {
      return a.department.localeCompare(b.department);
    }
    return 0; // 기본 (정렬 없음)
  });

  // select style
  const customSelectStyles = {
    control: (base: any, state: any) => ({
      ...base,
      borderColor: state.isFocused ? "#30a690" : base.borderColor,
      boxShadow: state.isFocused ? "0 0 0 1px #30a690" : base.boxShadow,
      "&:hover": {
        borderColor: state.isFocused ? "#30a690" : base.borderColor,
      },
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#30a690"
        : state.isFocused
        ? "#30a69020"
        : "white",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#30a690",
        color: "white",
      },
    }),
  };

  return (
    <BackupUserContainer>
      <ContentsTopHeader
        title="백업 사용자 목록"
        onSearch={handleSearch}
        onPageSizeChange={handlePageSizeChange}
        pageSizeHidden={true}
      />
      <ContentsBody>
        <div className="top">
          <div className="total">총 {data && data.length}</div>
          <div className="sort">
            <Select
              className="search-select"
              classNamePrefix="react-select"
              options={tableSort}
              onChange={handlePageSizeChange}
              defaultValue={tableSort[0]} // 기본값 설정
              components={{
                IndicatorSeparator: () => null,
              }}
              value={tableSort.find((option) => option.value === pageSize)} // ✅ 객체로 매칭
              styles={customSelectStyles} // ✅ 여기 추가
            />
          </div>
        </div>
        <UserList data={sortedData} isLoading={isLoading} />
      </ContentsBody>
    </BackupUserContainer>
  );
};

export default BackupUser;
